import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api, candidateApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for get all job timeline data
export const getJobTimeline = createAsyncThunk(
  "all/jobtimeline",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await api.get(`/req/job/job-timeline/?${queryParams}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for apply candidate on jobtimeline
export const applyCandidateOnJob = createAsyncThunk(
  "apply/candidateOnJob",
  async (values, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/req/job/recruiter-apply-timeline-job/",
        values
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get applied candidate by id
export const getAppliedCandidateById = createAsyncThunk(
  "applied/candidate",
  async (jobID, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/req/job/sale-recruiter-get-applied-job-application/${jobID}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all job timeline data
export const RemoveCandidateFromJob = createAsyncThunk(
  "remove/candidate",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/req/job/sale-recruiter-removed-applied-job-application/?${queryParams}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const jobTimelineSlice = createSlice({
  name: "jobtimeline",
  initialState: {
    data: null,
    appliedCandidateData: null,
    status: "idle",
    viewStaus: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getJobTimeline.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getJobTimeline.fulfilled, (state, action) => {
        state.status = "get_all_jobline_data";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getJobTimeline.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(applyCandidateOnJob.pending, (state) => {
        state.viewStaus = "loading";
      })
      .addCase(applyCandidateOnJob.fulfilled, (state, action) => {
        state.viewStaus = "apply_candidate_requirement_succsess";
        toast.success(action.payload?.message);
      })
      .addCase(applyCandidateOnJob.rejected, (state, action) => {
        state.viewStaus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getAppliedCandidateById.pending, (state) => {
        state.viewStaus = "loading";
      })
      .addCase(getAppliedCandidateById.fulfilled, (state, action) => {
        state.viewStaus = "get_applied_candidate_by_id";
        state.appliedCandidateData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getAppliedCandidateById.rejected, (state, action) => {
        state.viewStaus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(RemoveCandidateFromJob.pending, (state) => {
        state.viewStaus = "loading";
      })
      .addCase(RemoveCandidateFromJob.fulfilled, (state, action) => {
        state.viewStaus = "remove_candidate_suceed";
        // state.appliedCandidateData = action.payload;
        toast.success(action.payload?.message);
      })
      .addCase(RemoveCandidateFromJob.rejected, (state, action) => {
        state.viewStaus = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export default jobTimelineSlice.reducer;
